import { Platform } from 'react-native';
import styled from 'styled-components/native';
import { dimenWidth } from 'shared-components/src/utils/helper';

export default styled.View`
  margin-right: ${Platform.OS === 'web' ? '10' : dimenWidth(16)}px;
`;
